import { render } from "./CompanyAssets.vue?vue&type=template&id=5b096f5c"
import script from "./CompanyAssets.vue?vue&type=script&lang=js"
export * from "./CompanyAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__